import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '.';
import type { FYMTypes, OffersTypes, SuccessModalTypes } from '../types';

interface AppConfigProps {
  isSeparatePage: boolean;
  dealerId: string | null;
  vehicleId: string | null;
  vehicleType: string | null;
  presetForm: string | null;
  customForm: string[];
  market: string;
  carline: string | null;
  audiCode: string | null;
  ctaInnerText: string | null;
  adobeCloudId: string;
  device: string;
  campaignId: string;
  isOfferPage: boolean;
  offers: OffersTypes | null;
  fym: FYMTypes | null;
  dealerConsent: string | null;
  dealerConsentFr: string | null;
  tcpaConsent: string | null;
  secondTcpaConsent: string | null;
  ccpaDisclaimer: string | null;
  ccpaConsent: string | null;
  customDepartmentName: string | null;
  customPhoneNumber: string | null;
  successModalConfig: SuccessModalTypes;
  topicOfInterests: string[];
  requestType: string | null;
  handraiser: string | null;
  formTitle?: string | null;
  derivativeCode?: string[] | null;
  modelSelect?: string[] | null;
}

const initialState: AppConfigProps = {
  isSeparatePage: false,
  dealerId: null,
  vehicleId: null,
  vehicleType: null,
  presetForm: null,
  ctaInnerText: null,
  carline: null,
  audiCode: null,
  customForm: [],
  market: 'USA',
  adobeCloudId: '',
  device: '',
  campaignId: '',
  isOfferPage: false,
  offers: null,
  fym: null,
  dealerConsent: null,
  dealerConsentFr: null,
  tcpaConsent: null,
  secondTcpaConsent: null,
  ccpaDisclaimer: null,
  ccpaConsent: null,
  customDepartmentName: null,
  customPhoneNumber: null,
  successModalConfig: {
    successCustomHeading: null,
    successCustomBody: null,
    successCustomCtaVerbiage: null,
    successCustomCtaUrl: null,
  },
  topicOfInterests: [],
  requestType: null,
  handraiser: null,
  formTitle: null,
  derivativeCode: null,
  modelSelect: null,
};

const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    setAppConfig: (state, action) => {
      return { ...state, ...action.payload };
    },
    setRemoveOffersAndFYM: (state) => {
      return { ...state, offers: null, fym: null };
    },
    setClearVehicleData: (state) => {
      return { ...state, vehicleId: '', audiCode: '', carline: '', presetForm: null };
    },
    setDefaultConfig: () => {
      return initialState;
    },
  },
});

export const selectAppConfig = (state: RootState) => state.appConfig;

export const { setAppConfig, setDefaultConfig, setRemoveOffersAndFYM, setClearVehicleData } =
  appConfigSlice.actions;

export default appConfigSlice.reducer;
